import { Mail } from 'lucide-react';
import { z } from 'zod';
import { TextFieldInput, TextFieldView } from '../renderers/fields/text/text-field';
import type { EmailFieldSchema, FieldDefinition } from '../types';

export const EmailDefinition: FieldDefinition<EmailFieldSchema, string | null | undefined> = {
  type: 'email',
  toolboxLabel: 'Email Input',
  category: 'Standard Inputs',
  description: 'A text field optimized for email addresses with validation.',
  icon: Mail,

  createDefault: (id) => ({
    id,
    type: 'email',
    name: `email_${id}`,
    label: 'Email Address',
    required: false,
    placeholder: 'Enter email...',
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'placeholder',
      type: 'text',
      name: 'placeholder',
      label: 'Placeholder Text',
      required: false,
    },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required Field',
      required: false,
    },
  ],

  buildValidation: (field) => {
    const schema = z.string({ error: `${field.label} is required` }).email('Invalid email address');

    if (field.required) {
      return schema.min(1, `${field.label} is required`);
    }

    return schema.optional().or(z.literal(''));
  },

  // Reuse text field components but they will use type="email" if we update them
  editComponent: TextFieldInput,
  viewComponent: TextFieldView,
};
